import axios from "axios";
import Vue from "vue";

const devInstance = createInstance("localhost:1234");
const productionInstance = createInstance(
  "https://us-central1-shopping-time-97f96.cloudfunctions.net"
);

function createInstance(baseURL) {
  return axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json"
    }
  });
}

export default {
  install() {
    if (process.env.NODE_ENV == "production")
      Vue.prototype.$axios = productionInstance;
    else Vue.prototype.$axios = devInstance;
  }
}; // Check debug/build mode
